import React from 'react';

import { PageContainer } from '../../../shared/ui';

const YowanFooter = () => {
  return (
    <footer className="yowan-shell__footer">
      <PageContainer className="yowan-shell__footer-inner">
        <div className="yowan-shell__footer-minimal">
          <p className="yowan-shell__footer-copy">©2024 Yowan</p>
        </div>
        <p className="yowan-shell__footer-recaptcha">This site is protected by reCAPTCHA.</p>
      </PageContainer>
    </footer>
  );
};

export default YowanFooter;
